import { create } from "zustand";
import { persist } from "zustand/middleware";
import { FORM_FIELDS } from "../constants";
import type { RequestShippingAgencyTransferFormData } from "../schema/requestShippingAgencyTransferSchema";

export const PERSIST_KEY = "request-shipping-agency-transfer-form";

interface RequestShippingAgencyTransferFormMethods {
  setField<K extends keyof RequestShippingAgencyTransferFormData>(
    key: K,
    val: RequestShippingAgencyTransferFormData[K],
  ): void;
  setAll(data: Partial<RequestShippingAgencyTransferFormData>): void;
  resetForm(): void;
}

type RequestShippingAgencyTransferFormState = RequestShippingAgencyTransferFormData &
  RequestShippingAgencyTransferFormMethods;

const defaultValues: Omit<
  RequestShippingAgencyTransferFormData,
  keyof RequestShippingAgencyTransferFormMethods
> = {
  [FORM_FIELDS.NEW_SHIPPING_AGENCY]: "",
  [FORM_FIELDS.TRANSFER_DATE_AND_TIME]: "",
  [FORM_FIELDS.ADDITIONAL_DOCUMENTS]: [],
};

export const useShippingAgencyTransferStore = create<RequestShippingAgencyTransferFormState>()(
  persist(
    (set) => ({
      ...(defaultValues as RequestShippingAgencyTransferFormState),

      setField: (key, val) => set((s) => ({ ...s, [key]: val })),
      setAll: (data) => set((s) => ({ ...s, ...data })),
      resetForm: () => set((state) => ({ ...state, ...defaultValues })),
    }),
    { name: PERSIST_KEY },
  ),
);
